module.exports = __webpack_public_path__ + "static/media/productCont.41868af5.png";